import { getBackNavigation } from './utils/backNavigation';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import App from './App';
import { dismissKeyboard } from './utils/dismissKeyboard';
import { colors, shape, FONT_FAMILY } from './design/tokens';

const theme = createTheme({
    palette: {
        primary: { main: colors.brand, light: colors.brandLight, dark: colors.brandHover },
        error: { main: colors.error },
        background: { default: colors.canvas },
    },
    typography: {
        fontFamily: FONT_FAMILY,
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                // Korean prose wraps at word boundaries. Long user-entered tokens may
                // still wrap as a last resort; compact option labels set nowrap locally.
                body: { wordBreak: 'keep-all', overflowWrap: 'break-word' },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: shape.controlRadius,
                    textTransform: 'none',
                    fontWeight: 600,
                },
            },
        },
        MuiDialog: {
            defaultProps: {
                onTransitionEnter: dismissKeyboard,
            },
        },
    },
});

const IosWatchAlarmPreview = process.env.NODE_ENV === 'development'
    && ['localhost', '127.0.0.1'].includes(window.location.hostname)
    && window.location.pathname === '/dev/ios-watch-alarm'
    ? React.lazy(() => import('./dev/IosWatchAlarmPreview')) : null;

const FeatureUpdatePreview = process.env.NODE_ENV === 'development'
    && ['localhost', '127.0.0.1'].includes(window.location.hostname)
    && window.location.pathname === '/dev/feature-update'
    ? React.lazy(() => import('./dev/FeatureUpdatePreview')) : null;

getBackNavigation();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
            {FeatureUpdatePreview ? <React.Suspense fallback={null}><FeatureUpdatePreview /></React.Suspense> : IosWatchAlarmPreview ? <React.Suspense fallback={null}><IosWatchAlarmPreview /></React.Suspense> : <App />}
        </BrowserRouter>
    </ThemeProvider>
);
